var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { isRef, computed, ref, getCurrentInstance } from "vue";
class FormValidator {
  constructor(name, formInstance) {
    __publicField(this, "_name");
    __publicField(this, "_formInstance");
    __publicField(this, "_scrollToErrorFn");
    this._name = name;
    this._formInstance = formInstance;
  }
  get name() {
    return this._name;
  }
  async scrollToError(validationResult) {
    if (validationResult.isValid) {
      return;
    }
    if (this._scrollToErrorFn) {
      await this._scrollToErrorFn(this, validationResult);
    }
    const instance = isRef(this._formInstance) ? this._formInstance.value : this._formInstance;
    if (instance && validationResult.invalidFields) {
      const key = Object.keys(validationResult.invalidFields)[0];
      if (key) {
        const field = validationResult.invalidFields[key][0].field;
        if (field) {
          const formItem = instance.fields.find((f) => f.prop === field);
          if (formItem) {
            setTimeout(() => {
              var _a;
              (_a = formItem.$el) == null ? void 0 : _a.scrollIntoView({ behavior: "auto", block: "center", inline: "nearest" });
            }, 1e3);
          }
        }
      }
    }
  }
  clearValidate() {
    const instance = isRef(this._formInstance) ? this._formInstance.value : this._formInstance;
    instance == null ? void 0 : instance.clearValidate();
  }
  validate() {
    const that = this;
    return new Promise((resolve, reject) => {
      const instance = isRef(that._formInstance) ? that._formInstance.value : that._formInstance;
      if (instance) {
        instance.validate((isValid, invalidFields) => {
          resolve({ name: that._name, isValid, invalidFields, validator: that });
          console.log(`${that._name} 表单校验完成!`);
        }).catch((reason) => {
          console.log(`${that._name} 表单校验出现异常!`);
          reject(reason);
        });
        console.log(`${that._name} 表单校验调用!`);
      } else {
        resolve({ name: that._name, isValid: true });
        console.log(`${that._name} 表单校验完成!`);
      }
    });
  }
  withNameSuffix(suffix) {
    this._name = `${this.name}.${suffix}`;
    return this;
  }
  withScrollToError(scrollToErrorFn) {
    this._scrollToErrorFn = scrollToErrorFn;
    return this;
  }
}
const tryConvertToFormValidator = (arg) => {
  if (!arg) {
    return void 0;
  }
  if (Array.isArray(arg)) {
    return arg.map((i) => isRef(i) ? i.value : i).filter((i) => i !== void 0);
  }
  return isRef(arg) ? arg.value : arg;
};
const executeClearValidate = (arg) => {
  if (!arg) {
    return;
  }
  try {
    return arg == null ? void 0 : arg.clearValidate();
  } catch (error) {
    try {
      console.log(`name:${arg.name} ,异常:${JSON.stringify(error)}`);
    } catch {
      console.log(`name:${arg.name}`);
    }
  }
};
class MultipleFormValidator {
  constructor(name, items) {
    __publicField(this, "_name");
    __publicField(this, "_formValidatorItems");
    __publicField(this, "_scrollToErrorFn");
    this._name = name;
    this._formValidatorItems = items;
  }
  get name() {
    return this._name;
  }
  async scrollToError(validationResult) {
    var _a;
    if (validationResult.isValid) {
      return;
    }
    if (this._scrollToErrorFn) {
      await this._scrollToErrorFn(this, validationResult);
    }
    if (validationResult.childResults && validationResult.childResults.length > 0) {
      await ((_a = validationResult.childResults[0].validator) == null ? void 0 : _a.scrollToError(validationResult.childResults[0]));
    }
  }
  clearValidate() {
    for (let i = 0; i < this._formValidatorItems.length; i++) {
      const validator = tryConvertToFormValidator(this._formValidatorItems[i]);
      if (!validator) {
        continue;
      }
      if (Array.isArray(validator)) {
        for (let j = 0; j < validator.length; j++) {
          executeClearValidate(validator[j]);
        }
      } else {
        executeClearValidate(validator);
      }
    }
  }
  validate() {
    const that = this;
    return new Promise((resolve, reject) => {
      try {
        if (that._formValidatorItems.length === 0) {
          resolve({ name: that._name, isValid: true });
          return;
        }
        const formValidationResults = [];
        for (let i = 0; i < that._formValidatorItems.length; i++) {
          const validator = tryConvertToFormValidator(that._formValidatorItems[i]);
          if (!validator) {
            continue;
          }
          if (Array.isArray(validator)) {
            for (let j = 0; j < validator.length; j++) {
              if (!validator[j]) {
                continue;
              }
              formValidationResults.push(validator[j].validate());
            }
          } else {
            formValidationResults.push(validator.validate());
          }
        }
        if (formValidationResults.length == 0) {
          resolve({ name: that._name, isValid: true });
          return;
        }
        Promise.all(formValidationResults).then((results) => {
          try {
            const errorResults = results.filter((r) => !r.isValid);
            if (errorResults.length > 0) {
              resolve({
                name: that._name,
                isValid: false,
                childResults: errorResults,
                validator: that
              });
            } else {
              resolve({ name: that._name, isValid: true });
            }
          } catch (error) {
            reject({ name: that._name, error });
          }
        }).catch((reason) => {
          reject({ name: that._name, error: reason });
        });
      } catch (error) {
        reject({ name: that._name, error });
      }
    });
  }
  withNameSuffix(suffix) {
    this._name = `${this.name}.${suffix}`;
    return this;
  }
  withScrollToError(scrollToErrorFn) {
    this._scrollToErrorFn = scrollToErrorFn;
    return this;
  }
}
const getValidatorArrayFromArray = (componentInstances) => {
  return componentInstances.filter((item) => !!item).map((item, index) => {
    var _a;
    return (_a = item == null ? void 0 : item.formValidator) == null ? void 0 : _a.withNameSuffix(index);
  });
};
const getValidatorArrayFromMap = (componentInstanceMap) => {
  const formValidators = [];
  componentInstanceMap.forEach((value, key) => {
    var _a;
    if (!value) {
      return;
    }
    formValidators.push((_a = value.formValidator) == null ? void 0 : _a.withNameSuffix(key));
  });
  return formValidators.filter((v) => !!v);
};
const useNamedValidatorArrayValidator = (name, componentInstances) => {
  if (Array.isArray(componentInstances)) {
    const formValidators = getValidatorArrayFromArray(componentInstances);
    return useNamedMultipleFormValidator(name, formValidators);
  } else {
    const formValidators = computed(() => getValidatorArrayFromArray(componentInstances.value));
    return useNamedMultipleFormValidator(name, formValidators);
  }
};
const useNamedFormValidatorArrayWrapper = (name) => {
  const componentInstances = ref([]);
  const addComponentInstance = (component, index) => {
    if (!component) {
      return;
    }
    componentInstances.value[index] = component;
  };
  const removeComponentInstance = (index) => {
    componentInstances.value.splice(index, 1);
  };
  const removeComponentInstanceIf = (predicate) => {
    componentInstances.value = componentInstances.value.filter((item, index) => !predicate(item, index));
  };
  return {
    componentInstances,
    addComponentInstance,
    removeComponentInstance,
    removeComponentInstanceIf,
    validator: useNamedValidatorArrayValidator(name, componentInstances)
  };
};
const useFormValidatorArrayWrapper = () => {
  const instance = getCurrentInstance();
  if (instance == null) {
    throw new Error("component instance can not null");
  }
  const name = instance.type.name || instance.type.__name;
  if (name == void 0) {
    throw new Error("component name cannot be null");
  }
  return useNamedFormValidatorArrayWrapper(name);
};
const useNamedFormValidatorMapValidator = (name, componentInstanceMap) => {
  if (isRef(componentInstanceMap)) {
    const formValidators = computed(() => getValidatorArrayFromMap(componentInstanceMap.value));
    return useNamedMultipleFormValidator(name, formValidators);
  } else {
    const formValidators = getValidatorArrayFromMap(componentInstanceMap);
    return useNamedMultipleFormValidator(name, formValidators);
  }
};
const useNamedFormValidatorMapWrapper = (name) => {
  const componentInstanceMap = ref(/* @__PURE__ */ new Map());
  const addComponentInstance = (componentInstance, key) => {
    if (!componentInstance) {
      return;
    }
    componentInstanceMap.value.set(key, componentInstance);
  };
  const removeComponentInstanceIf = (predicate) => {
    const deleteKeys = [];
    componentInstanceMap.value.forEach((item, key) => {
      if (predicate(key, item)) {
        deleteKeys.push(item);
      }
    });
    if (deleteKeys.length > 0) {
      deleteKeys.forEach((key) => componentInstanceMap.value.delete(key));
    }
  };
  const removeComponentInstance = (key) => componentInstanceMap.value.delete(key);
  return {
    componentInstanceMap,
    addComponentInstance,
    removeComponentInstance,
    removeComponentInstanceIf,
    validator: useNamedFormValidatorMapValidator(name, componentInstanceMap)
  };
};
const useFormValidatorMapWrapper = () => {
  const instance = getCurrentInstance();
  if (instance == null) {
    throw new Error("component instance can not null");
  }
  const name = instance.type.name || instance.type.__name;
  if (name == void 0) {
    throw new Error("component name cannot be null");
  }
  return useNamedFormValidatorMapWrapper(name);
};
const getFormValidatorsByFromInstanceArray = (name, formInstances) => {
  return formInstances.filter((item) => !!item).map((item, index2) => useNamedFormValidator(`${name}.${index2}`, item));
};
const getFormValidatorsByFromInstanceMap = (name, formInstanceMap) => {
  const formValidators = [];
  formInstanceMap.forEach((value, key) => {
    if (!!value) {
      formValidators.push(useNamedFormValidator(`${name}.${key}`, value));
    }
  });
  return formValidators;
};
const useNamedFormInstanceArrayValidator = (name, formInstances) => {
  if (Array.isArray(formInstances)) {
    const formValidators = getFormValidatorsByFromInstanceArray(name, formInstances);
    return useNamedMultipleFormValidator(name, formValidators);
  } else {
    const formValidators = computed(() => getFormValidatorsByFromInstanceArray(name, formInstances.value));
    return useNamedMultipleFormValidator(name, formValidators);
  }
};
const useNamedFormInstanceArrayWrapper = (name) => {
  const formInstances = ref([]);
  const addFormInstance = (formInstance, index2) => {
    formInstances.value[index2] = formInstance;
  };
  const removeFormInstanceIf = (predicate) => {
    formInstances.value = formInstances.value.filter((item, index2) => !predicate(item, index2));
  };
  const removeFormInstance = (index2) => {
    formInstances.value.splice(index2, 1);
  };
  return {
    formInstances,
    addFormInstance,
    removeFormInstance,
    removeFormInstanceIf,
    validator: useNamedFormInstanceArrayValidator(name, formInstances)
  };
};
const useFormInstanceArrayWrapper = () => {
  const instance = getCurrentInstance();
  if (instance == null) {
    throw new Error("component instance can not null");
  }
  const name = instance.type.name || instance.type.__name;
  if (name == void 0) {
    throw new Error("component name cannot be null");
  }
  return useNamedFormInstanceArrayWrapper(name);
};
const useNamedFormInstanceMapValidator = (name, formInstancesMap) => {
  if (isRef(formInstancesMap)) {
    const formValidators = computed(() => getFormValidatorsByFromInstanceMap(name, formInstancesMap.value));
    return useNamedMultipleFormValidator(name, formValidators);
  } else {
    const formValidators = getFormValidatorsByFromInstanceMap(name, formInstancesMap);
    return useNamedMultipleFormValidator(name, formValidators);
  }
};
const useNamedFormInstanceMapWrapper = (name) => {
  const formInstanceMap = ref(/* @__PURE__ */ new Map());
  const addFormInstance = (formInstance, key) => {
    formInstanceMap.value.set(key, formInstance);
  };
  const removeFormInstance = (key) => formInstanceMap.value.delete(key);
  const removeFormInstanceIf = (predicate) => {
    const deleteKeys = [];
    formInstanceMap.value.forEach((value, key) => {
      if (predicate(key, value)) {
        deleteKeys.push(key);
      }
    });
    if (deleteKeys.length > 0) {
      deleteKeys.forEach((key) => formInstanceMap.value.delete(key));
    }
  };
  return {
    formInstanceMap,
    addFormInstance,
    removeFormInstance,
    removeFormInstanceIf,
    validator: useNamedFormInstanceMapValidator(name, formInstanceMap)
  };
};
const useFormInstanceMapWrapper = () => {
  const instance = getCurrentInstance();
  if (instance == null) {
    throw new Error("component instance can not null");
  }
  const name = instance.type.name || instance.type.__name;
  if (name == void 0) {
    throw new Error("component name cannot be null");
  }
  return useNamedFormInstanceMapWrapper(name);
};
const useNamedMultipleFormValidator = (name, ...args) => {
  return new MultipleFormValidator(name, args);
};
const useMultipleFormValidator = (...args) => {
  const instance = getCurrentInstance();
  if (instance == null) {
    throw new Error("component instance can not null");
  }
  const name = instance.type.name || instance.type.__name;
  if (name == void 0) {
    throw new Error("component name cannot be null");
  }
  return new MultipleFormValidator(name, args);
};
const useNamedFormValidator = (name, formInstance) => {
  return new FormValidator(name, formInstance);
};
const useFormValidator = (formInstance) => {
  const instance = getCurrentInstance();
  if (instance == null) {
    throw new Error("component instance can not null");
  }
  const name = instance.type.name || instance.type.__name;
  if (name == void 0) {
    throw new Error("component name cannot be null");
  }
  return new FormValidator(name, formInstance);
};
export {
  FormValidator,
  MultipleFormValidator,
  useFormInstanceArrayWrapper,
  useFormInstanceMapWrapper,
  useFormValidator,
  useFormValidatorArrayWrapper,
  useFormValidatorMapWrapper,
  useMultipleFormValidator,
  useNamedFormInstanceArrayValidator,
  useNamedFormInstanceArrayWrapper,
  useNamedFormInstanceMapValidator,
  useNamedFormInstanceMapWrapper,
  useNamedFormValidator,
  useNamedFormValidatorArrayWrapper,
  useNamedFormValidatorMapValidator,
  useNamedFormValidatorMapWrapper,
  useNamedMultipleFormValidator,
  useNamedValidatorArrayValidator
};
